import { useQuery } from "@tanstack/react-query";
import type { EmailEventResult } from "@shared/emailCalendar";
import { inboxApi } from "@web/lib/inboxApi";
import { Button } from "@web/ui/Button";
export function EventResult({
  result,
  onClose,
}: {
  result: EmailEventResult;
  onClose: () => void;
}) {
  const work = useQuery({
    queryKey: ["threadWork", result.work.id],
    queryFn: () => inboxApi.work(result.work.id),
    initialData: result.work,
    refetchInterval: (q) =>
      ["queued", "working"].includes(q.state.data?.status ?? "") ? 2000 : false,
  });
  const receipts = useQuery({
    queryKey: ["emailEventReceipts", result.work.id, work.data.status],
    queryFn: () => inboxApi.workReceipts(result.work.id),
    enabled: work.data.status === "completed",
  });
  const href = receipts.data
    ?.map((r) => r.readback.htmlLink)
    .find(
      (x): x is string => typeof x === "string" && x.startsWith("https://calendar.google.com/"),
    );
  const cancelled = work.data.status === "cancelled";
  const done = work.data.status === "completed";
  const pending = ["queued", "working"].includes(work.data.status);
  return (
    <div className="flex flex-col gap-4 p-5">
      <h2 className="text-2xl">
        {cancelled
          ? "Not added"
          : done
            ? "Added to your calendar"
            : pending
              ? "Adding to your calendar…"
              : "Calendar event needs attention"}
      </h2>
      <p className="text-muted">
        {cancelled
          ? "This calendar action was cancelled. No event was added."
          : done
            ? "Saved as a private event. No invitations were sent."
            : pending
              ? "You can cancel during the short undo window. Check here or Under way for the result."
              : work.data.resultText || "Open Under way to review the result before trying again."}
      </p>
      {href ? (
        <a
          className="text-accent-text underline"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open event in Google Calendar
        </a>
      ) : null}
      <Button onClick={onClose}>Close</Button>
    </div>
  );
}
